(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/redbeemedia/assets/javascripts/video-player-utils.js') >= 0) return;  svs.modules.push('/components/components/redbeemedia/assets/javascripts/video-player-utils.js');

'use strict';

var displayTime = function displayTime(t, last) {
  return t > 0 ? (t <= 9 ? "0".concat(t) : t) + (!last ? ':' : '') : last ? '00' : '00:';
};

var removeEmptyTime = function removeEmptyTime(t) {
  if (parseInt(t === null || t === void 0 ? void 0 : t.replace(':', ''), 10)) {
    return t;
  }
  return '';
};

var secondsToHms = function secondsToHms(s) {
  var sec = Number(s);
  var hours = Math.floor(sec / 3600);
  var minutes = Math.floor(sec % 3600 / 60);
  var seconds = Math.floor(sec % 3600 % 60);
  var h = removeEmptyTime(displayTime(hours));
  var m = displayTime(minutes);
  var _s = displayTime(seconds, true);
  return "".concat(h).concat(m).concat(_s);
};

var volumeStrengthIndicator = function volumeStrengthIndicator(volume) {
  if (volume === 0) {
    return 'icon-volyme-off';
  } else if (volume <= 33) {
    return 'icon-volume-low';
  } else if (volume <= 66) {
    return 'icon-volume-medium';
  } else if (volume <= 100) {
    return 'icon-volyme-on';
  }
};

var secondsDate = function secondsDate(timestamp) {
  return Math.floor(new Date(timestamp).getTime() / 1000);
};
svs.components.redbee_video_player.Utils = {
  secondsDate: secondsDate,
  volumeStrengthIndicator: volumeStrengthIndicator,
  secondsToHms: secondsToHms,
  removeEmptyTime: removeEmptyTime,
  displayTime: displayTime
};

 })(window);